import { Component, getAssetPath, h, Host, State, ComponentInterface } from '@stencil/core';
import { BsWebcomponent } from '../bahf-header/bsWebcomponent';
import { HfUtil } from '../bahf-header/utils/HfUtil';
import { I18nUtil } from '../../utils/I18nUtil';
import { fetchAndStore } from '../bahf-header/utils/fetchAndStore';
import globalStore from '../../stores/globalStore';
import { HeaderMode } from '../bahf-header/types/header-mode';


@Component({
  tag: 'bahf-footer',
  styleUrl: 'bahf-footer.scss',
  assetsDirs: ['assets'],
  shadow: true,
})
export class BahfFooter implements ComponentInterface {

  private footerElem: HTMLElement;
  @State() private jsonData;
  @State() private language: string;
  @State() private withCookieDisclaimer: boolean = document.querySelector('bahf-header')?.withCookieDisclaimer || false;
  private currentYear: string = new Date().getFullYear().toString();


  componentWillLoad() {
    const mode: HeaderMode = document.querySelector('bahf-header')?.mode;
    this.language = I18nUtil.getCurrentLang(mode !== HeaderMode.International);
    fetchAndStore(`assets/footer.${this.language}.json`)
      .then((data) => this.jsonData = data);
  }

  componentDidRender() {
    this.footerElem && new BsWebcomponent(this.footerElem);
  }

  componentDidLoad() {
    const fallback = document.querySelector('bahf-fallback-footer');
    if (fallback) {
      fallback.parentNode.removeChild(fallback);
    }
    this.footerElem && this.footerElem.classList.remove('initializing');
  }

  render() {
    return (
      <Host>
        <footer class="ba-footer-wrap" lang={this.language}>

          {this.jsonData &&
            <section class="ba-footer" ref={(el: HTMLElement) => (this.footerElem = el)}>
              <div class="container-fluid">
                {globalStore.state.mode !== HeaderMode.International && this.jsonData.footerSocialLinks &&
                  <div class="ba-social-links">
                    <h2 class="h4">{this.jsonData.footerSocialHeadline}</h2>
                    <ul class="ba-social-icons">
                      {this.jsonData.footerSocialLinks.map((link) => (
                         <li key={HfUtil.uniqueKey('footerSocialLinks')}>
                          <a href={link.href}
                             class={'ba-icon ' + link.class}
                             title={link.title}
                             target="_blank"></a></li>
                        ))}
                    </ul>
                  </div>
                }
                {globalStore.state.mode !== HeaderMode.International && this.jsonData.footerLinkBlocks &&
                  <nav class="row"
                       data-testid="bahf-footer-link-block">
                    {this.jsonData.footerLinkBlocks.map((footerblock: {title: string, id: string, links: []}) =>
                      <div class="col-12 col-md-6 col-lg-3" key={footerblock.id}>
                        <button class="ba-collapse-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target={'#footerArea' + String(footerblock.id)} aria-expanded="false"
                                aria-controls={'footerArea' + String(footerblock.id)}>
                          {footerblock.title}
                        </button>
                        <div class="collapse" id={'footerArea' + String(footerblock.id)}>
                          <h2 id={'footer-desc-' + String(footerblock.id)} class="h6">{footerblock.title}</h2>
                          <ul key={HfUtil.uniqueKey('links')}
                              aria-labelledby={'footer-desc-' + String(footerblock.id)}>
                            {
                              footerblock.links?.map((link: { title: string, url: string }) =>
                                <li key={link.title}>
                                  <a target="_blank" rel="noopener" href={link.url}>{link.title}</a>
                                </li>
                              )
                            }
                          </ul>
                        </div>
                      </div>
                    )}
                  </nav>
                }
              </div>
              <hr />
              {this.jsonData.footerBottomLine &&
                <nav class="container-fluid position-relative"
                     aria-label={this.jsonData.footerBottomLine.ariaLabel}
                     data-testid="bahf-footer-bottom">
                  <picture class="ba-logo">
                    <img src={getAssetPath(this.jsonData.footerBottomLine.logo)}
                         alt="" />
                  </picture>

                  {this.renderFooterBottomLineLinks()}

                </nav>
              }
            </section>
          }
        </footer>
      </Host>
    );
  }

  private renderFooterBottomLineLinks() {
    if (!this.jsonData.footerBottomLine.links) return null;

    const renderedLinks: HTMLLIElement[] = this.jsonData.footerBottomLine.links
      .map((link) => (<li key={link.title}>
        <a target={link.target || '_blank'} rel="noopener"
           href={link.url}>{link.title}
        </a></li>)
      );

    if (this.withCookieDisclaimer) {
      renderedLinks.splice(3, 1, <li>
        <a onClick={this.openCookieDisclaimer}
           href="#"
           role="button"
           target="_self">{this.jsonData.footerBottomLine.links[3].title}</a>
      </li>);
    } else {
      renderedLinks.splice(3, 1);
    }

    return (
      <ul class="ba-list-meta">
        {
          renderedLinks.map((link: HTMLLIElement) => (link))
        }
        <li>{this.jsonData.footerBottomLine.title} {this.currentYear}</li>
      </ul>
    );
  }

  private openCookieDisclaimer(event: Event) {
    event.preventDefault();
    document.querySelector('bahf-cookie-disclaimer-dpl3').forceVisible = true;
  }

}
